<aside class="amendment-summary">
  <div>
    <span class="key">Salarié :</span> <span class="value">{{ employee() }}</span>
  </div>
  <div>
    <span class="key">Contrat :</span> <span class="value">{{ contractLabel() }}</span>
  </div>
  <div>
    <span class="key">Effet au :</span> <span class="value">{{ effectiveDateLabel() }}</span>
  </div>
  @if (durationLabel()) {
    <div>
      <span class="key">Durée :</span> <span class="value">{{ durationLabel() }}</span>
    </div>
  }

  @if (reasons(); as reasons) {
    <div class="section key">Volume hebdomadaire</div>
    <div>
      @if (reasons.weeklyWorkingHoursInForce !== reasons.weeklyWorkingHours) {
        <span class="before">{{ reasons.weeklyWorkingHoursInForce | number: '1.2-2' }}h/sem</span>
        →
      }
      <span class="after">{{ reasons.weeklyWorkingHours | number: '1.2-2' }}h/sem</span>
    </div>

    <div class="section key">Affectation</div>
    <div class="value">{{ assignmentLabel() }}</div>

    <div class="section key">Ce que la saisie établit</div>
    @for (reason of reasons.reasons; track reason.code) {
      <div>
        <span class="reason">{{ reason.label }}</span>
      </div>
    } @empty {
      <div class="value">Aucun : rien ne change</div>
    }
  }

  @if (fileName(); as fileName) {
    <div class="section key">Fichier</div>
    <div class="value file-name">{{ fileName }}.pdf</div>
  }
</aside>
